module.exports = __webpack_public_path__ + "img/lPutHB.e1543fd5.svg";